import { SVLabeledText, SVLink } from '@/components/core';
import { ROUTES } from '@/constants/routes';
import { KYCEvaluation } from '@/types/bankApplications';
import { formatDateTimeFromUTC } from '@/utils/date';
import { titleCase } from '@/utils/stringCaser';
import { Card, Typography, Grid, Box, Stack } from '@mui/material';

type BankApplicationKYCInfoProps = {
  isBusinessAccount: boolean;
  kycEvaluations: KYCEvaluation[];
};

export default function BankApplicationKYCInfo({
  isBusinessAccount,
  kycEvaluations,
}: BankApplicationKYCInfoProps) {
  if (!kycEvaluations || kycEvaluations.length === 0) {
    return null;
  }

  return (
    <Card sx={{ p: 3 }}>
      <Typography variant="h5" mb={3}>
        {isBusinessAccount ? 'KYB' : 'KYC'} Evaluations
      </Typography>
      <Grid container spacing={3}>
        {kycEvaluations.map(evaluation => (
          <Grid
            size={{ xs: 12, md: 6, lg: 4, xl: 3 }}
            key={evaluation.businessId || evaluation.consumerId}>
            <Box
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}>
              <Stack spacing={2}>
                <SVLabeledText
                  label="Owner"
                  customContent={
                    evaluation.business ? (
                      <SVLink
                        to={`${ROUTES.BUSINESSES}/${evaluation.business.uuid}`}>
                        {evaluation.business.name}
                      </SVLink>
                    ) : evaluation.consumer ? (
                      <SVLink
                        to={`${ROUTES.CUSTOMERS}/${evaluation.consumer.uuid}`}>
                        {evaluation.consumer.fullName}
                      </SVLink>
                    ) : null
                  }
                />
                <SVLabeledText
                  label="Created At"
                  text={formatDateTimeFromUTC(evaluation.createdByThirdPartyAt)}
                />
                <SVLabeledText
                  label="Status"
                  text={titleCase(evaluation.status || '')}
                />
                <SVLabeledText
                  label="Outcome"
                  text={titleCase(evaluation.outcome || '')}
                />
                <SVLabeledText
                  label="Score"
                  text={evaluation.score?.toString()}
                />
                {evaluation.kycEvaluationLink && (
                  <SVLink to={evaluation.kycEvaluationLink} target="_blank">
                    View Evaluation
                  </SVLink>
                )}
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}
